import { supabase } from '../clients/supabaseClient';

export type Step = { action: string; detail?: string };
export type Callout = { type: 'tip' | 'warn' | 'note'; text: string };
export type Block =
    | { kind: 'body'; text: string }
    | { kind: 'steps'; items: Step[] }
    | { kind: 'bullets'; items: string[] }
    | { kind: 'callout'; callout: Callout }
    | { kind: 'checklist'; items: string[] }
    | { kind: 'statuses'; rows: [string, string, string][] };

export type HandbookSectionRow = {
    section_key: string;
    parent_key: string | null;
    number: string;
    title: string;
    screenshot: string | null;
    blocks: Block[];
    sort_order: number;
};

export async function fetchHandbookSections(): Promise<HandbookSectionRow[]> {
    const { data, error } = await supabase
        .from('operations_handbook')
        .select('section_key, parent_key, number, title, screenshot, blocks, sort_order')
        .order('sort_order', { ascending: true });

    if (error) throw error;
    return (data ?? []) as HandbookSectionRow[];
}